import api from "@/api/axios";

export default {
  namespaced: true,
  state: () => ({
    items: [],
    allItems: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
      totalElements: 0
    }
  }),
  getters: {
    getItems: (state) => state.items,
    getAllItems: (state) => state.allItems,
    getPagination: (state) => state.pagination,
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setAllItems(state, items) {
      state.allItems = items;
    },
    setPagination(state, paginationData) {
      state.pagination = paginationData;
    }
  },
  actions: {
    async fetchAll({ commit, dispatch }) {
      try {
        dispatch('ui/startLoading', null, { root: true });
        const response = await api.get('/job/all');
        const jobsNormalized = normalizedJob(response.data);
        commit('setAllItems', jobsNormalized);
      } catch (error) {
        const msgError = 'Não possível carregar a lista de serviços';
        dispatch('ui/notify',  { 
          message: msgError, 
          color: 'error' 
        }, { root: true } );
        
        commit('setAllItems', []);
        console.error(`${msgError}: `, error);
      } finally {
        dispatch('ui/stopLoading', null, { root: true });
      }
    },
    async fetchAllOnPagination({ commit, dispatch }, params = {}) {
      try {
        dispatch('ui/startLoading', null, { root: true });

        const requestParams = {
          page: params.page || 0,
          size: params.size || 10,
          search: params.search || null,
        };

        if (params.startDate && params.endDate) {
          requestParams.startDate = params.startDate;
          requestParams.endDate = params.endDate;
        }

        const response = await api.get('/job/pagination', { params: requestParams });

        const jobsNormalized = normalizedJob(response.data.content);
        commit('setItems', jobsNormalized);
        commit('setPagination', {
          currentPage: response.data.number,
          totalPages: response.data.totalPages,
          totalElements: response.data.totalElements
        });
      } catch (error) {
        const msgError = 'Não possível carregar a lista de serviços';

        dispatch('ui/notify',  { 
          message: msgError, 
          color: 'error' 
        }, { root: true } );

        commit('setItems', []);
        commit('setPagination', { currentPage: 0, totalPages: 0, totalElements: 0 });
        
        console.error(`${msgError}: `, error);
      } finally {
        dispatch('ui/stopLoading', null, { root: true });
      }
    },
    async delete({ commit, dispatch }, id) {
      try {
        dispatch('ui/startLoading', null, { root: true });

        await api.delete(`job/delete/${id}`);
        await dispatch('fetchAll');
        await dispatch('fetchAllOnPagination');

        dispatch('ui/notify', {
          message: 'Serviço excluído com sucesso!',
          color: 'success'
        }, { root: true });

        return true;
      } catch (error) {
        dispatch('ui/notify',  { 
          message: 'Não foi possível excluir este serviço.', 
          color: 'error'
        }, { root: true } );
        console.error('Erro ao excluir o serviço: ', error);

        return false;
      } finally {
        dispatch('ui/stopLoading', null, { root: true });
      }
    },
    async save({ commit, dispatch }, newItem) {
      try {
        dispatch('ui/startLoading', null, { root: true });

        const response = await api.post('/job/save', newItem);
        await dispatch('fetchAll');
        await dispatch('fetchAllOnPagination');

        dispatch('ui/notify', {
          message: 'Serviço registrado com sucesso!',
          color: 'success'
        }, { root: true });

        return true;
      } catch (error) {
        console.error('Erro ao salvar um novo serviço: ', error);
        dispatch('ui/notify', {
          message: 'Erro ao tentar registrar este Serviço',
          color: 'error'
        },{ root: true });

        return false;
      } finally {
        dispatch('ui/stopLoading', null, { root: true });
      }
    },
    async update({ commit, dispatch }, editedItem) {
      try {
        dispatch('ui/startLoading', null, { root: true });

        const response = await api.put(`/job/update/${editedItem.id}`, editedItem);
        
        await dispatch('fetchAll');
        await dispatch('fetchAllOnPagination');

        dispatch('ui/notify', {
          message: 'Serviço atualizado com sucesso!',
          color: 'success'
        }, { root: true });

        return true;
      } catch (error) {
        console.error('Erro ao editar o serviço: ', error);
        
        dispatch('ui/notify', {
          message: 'Erro ao tentar atualizar este Serviço.',
          color: 'error'
        }, { root: true });

        return false;
      } finally {
        dispatch('ui/stopLoading', null, { root: true });
      }
    }
  }
}

/**
 * Normaliza os dados brutos vindos do Back-end.
 * Converte Enums para labels amigáveis e adiciona metadados.
 * @param {Array} data - Array de objetos vindos da API.
 * @returns {Array} Array de objetos normalizados.
 */
function normalizedJob(data) {
  if (!data || !Array.isArray(data)) return [];

  return data.map(item => ({
    ...item,
    entity: 'jobs'
  }));
}